import { Group } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { exportMultiReport } from "../../../services/report";
import {
  useSelectFiltersMultipleClientReport,
  useSelectReportsMultipleClientReport,
} from "../../../redux/features/reports/multipleClientReportSlice";
import { formatFiltersReports } from "../singleReport/utils";
import { toast } from "react-toastify";
import { REPORT_EXPORT_TYPE } from "../constants";
import ExportFileButton from "../../../components/ExportFileButton/ExportFileButton";

const downloadBlobResponse = (response) => {
  const fileName =
    response.headers["content-disposition"]?.split("filename=")[1];

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
};

const ExportMultiReports = () => {
  const { t } = useTranslation();

  const [currentType, setCurrentType] = useState(null);

  const multiFilters = formatFiltersReports(
    useSelectFiltersMultipleClientReport(),
  );
  const multiReports = useSelectReportsMultipleClientReport();

  const multiReportDownloadfile = useMutation({
    mutationKey: ["multi-client-report-download-file"],
    mutationFn: (reportExportType) =>
      exportMultiReport({
        ...multiFilters,
        forExport: true,
        reportExportType,
      }),
    onSuccess: downloadBlobResponse,
    onError: ({ message }) => {
      toast.error("Export error " + message);
    },
  });

  const handleDownload = async (option) => {
    setCurrentType(option);
    await multiReportDownloadfile.mutateAsync(option);
    setCurrentType(null);
  };

  const loading = multiReportDownloadfile.isPending;
  const noData = multiReports.length === 0;
  const disabled = loading || noData;

  return (
    <Group>
      <ExportFileButton
        handleDownload={() => handleDownload(REPORT_EXPORT_TYPE.PDF)}
        disabled={disabled}
        loading={loading && currentType === REPORT_EXPORT_TYPE.PDF}
        tooltipLabel={t("reports.exportPdf")}
        type={REPORT_EXPORT_TYPE.PDF}
      />
      <ExportFileButton
        handleDownload={() => handleDownload(REPORT_EXPORT_TYPE.EXCEL)}
        disabled={disabled}
        loading={loading && currentType === REPORT_EXPORT_TYPE.EXCEL}
        tooltipLabel={t("reports.exportExcel")}
        type={REPORT_EXPORT_TYPE.EXCEL}
      />
    </Group>
  );
};

export default ExportMultiReports;
